/* RESPONSIBLE TEAM: team-frontend-tech */
import BlockSerializer from './block';

const OPTIONAL_BLOCK_ATTRIBUTES = ['style'];

export default BlockSerializer.extend({
  optionalAttributes: OPTIONAL_BLOCK_ATTRIBUTES,
});
